import { Network } from '@tribeplatform/gql-client/types'
import { dayjs } from '@tribeplatform/react-components/common/lib'
import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

interface Props {
  network: Network
  emailFrom: string
  preview?: boolean
  domain?: string
}

export const FromEmailPreview = ({
  network,
  emailFrom,
  preview = false,
  domain = 'bettermode.com',
}: Props) => {
  const { data: member } = useAuthMember()

  return (
    <div className="shadow border border-line rounded-base p-3 text-sm flex-col space-y-1">
      <div className="flex space-s-3">
        <div className="w-24 flex-shrink-0 text-end text-content-subdued">
          from:
        </div>
        <div>
          <span className="font-bold">
            {member?.name?.split(' ')[0]} via {network?.name}
          </span>{' '}
          <span
            className={
              preview
                ? 'text-decorative-1 font-semibold'
                : 'text-content-subdued'
            }
          >
            &lt;
            {emailFrom || 'notifications@bettermode.com'}
            &gt;
          </span>
        </div>
      </div>
      <div className="flex space-s-3">
        <div className="w-24 flex-shrink-0 text-end text-content-subdued">
          to:
        </div>{' '}
        <div className="text-content">{member?.email}</div>
      </div>
      <div className="flex space-s-3">
        <div className="w-24 flex-shrink-0 text-end text-content-subdued">
          date:
        </div>{' '}
        <div className="text-content">
          {dayjs().format('MMM D, YYYY, h:mm A')}
        </div>
      </div>
      <div className="flex space-s-3">
        <div className="w-24 flex-shrink-0 text-end text-content-subdued">
          mailed-by:
        </div>{' '}
        <div
          className={
            preview ? 'text-decorative-1 font-semibold' : 'text-content'
          }
        >
          em5740.{domain}
        </div>
      </div>
      <div className="flex space-s-3">
        <div className="w-24 flex-shrink-0 text-end text-content-subdued">
          signed-by:
        </div>{' '}
        <div
          className={
            preview ? 'text-decorative-1 font-semibold' : 'text-content'
          }
        >
          {domain}
        </div>
      </div>
    </div>
  )
}
